module.exports = __webpack_public_path__ + "img/down.f6c2ff35.svg";